import { IWalletTransactionApiItem } from '@/ducks/billing/billing.types'

export const isWalletOrderPlaceholderName = (name?: string) =>
  /^Order\s+\S+/i.test(String(name || '').trim())

export const resolveWalletTransactionClient = (
  transaction: IWalletTransactionApiItem
) => {
  const customerName = transaction.customer_name?.trim()
  if (customerName) {
    return {
      clientName: customerName,
      clientAvatar: transaction.customer_avatar?.trim() || undefined
    }
  }

  const recipientName = transaction.recipient?.full_name?.trim()
  const senderName = transaction.sender?.full_name?.trim()
  const fallbackName =
    (recipientName && !isWalletOrderPlaceholderName(recipientName)
      ? recipientName
      : '') ||
    (senderName && !isWalletOrderPlaceholderName(senderName) ? senderName : '') ||
    '-'

  return {
    clientName: fallbackName,
    clientAvatar: undefined
  }
}
